import React from "react";
import { Helmet } from "react-helmet";
import HeaderTitle from "../../../../components/header/headerTitle/headerTitle";
import Image from "../../../../components/image";
import { asset } from "../../../../helpers/dom.helper";
import "./style.scss";
import { Link } from "react-router-dom";
import { toRoute } from "../../../../i18n";
import { Media, MediaContextProvider } from "../../../../media";
import { SHOPPING_AIDS_ITEM } from "./shoppingAidsJson";


function ShoppingAids(props) {


  return (
    <>
      <Helmet>
        <title>Shopping Aids | Lussopack</title>
        <meta name="description" content="Shopping Aids | Lussopack" />
        <meta name="keywords" content="Shopping Aids | Lussopack" />
        <link rel="canonical" href="https://lussopack.com/packaging/shopping-aids/" />  
      </Helmet>

      {/* <ScrollToTopOnMount /> */}
      <HeaderTitle
        {...props}
        textHeader={"Shopping Aids"}
      />
      <MediaContextProvider>
        <Media greaterThanOrEqual="md">
          <div id="shoppingAid">
              <h2>Jewelry trays</h2>
              <div className="shoppingAidsList">
              {
                SHOPPING_AIDS_ITEM.map((shoppingAid, index)=>(
                  <div className={`shoppingAidsItem`} key={index}>
                    <Link to={toRoute(shoppingAid.path)}>
                      <Image
                        src={asset(`${shoppingAid.itemImageDesktop}`)}
                        alt={`${shoppingAid.item}`}
                        className="img-fluid zoom"
                        width="345"
                        height="345"
                      />
                    </Link>
                    <Link to={toRoute(shoppingAid.path)}>
                      <p>{shoppingAid.item}</p>
                    </Link>
                  </div>
                ))
              }
            </div>
            <p><b>Jewelry trays</b> are a great way for jewelers to display their products and make them more appealing to customers. They can also be used to <b>organize jewelry</b> in a retail setting or to <b>store jewelry at home.</b> Lussopack's jewelry trays are a great way for jewelers to improve the presentation of their products and <b>increase sales.</b></p>
            <p>We offer a wide variety of trays in different materials, sizes, and colors to suit the needs of any jeweler. Our produced trays are made from <b>high-quality materials</b> and are designed to <b>protect jewelry from damage.</b> Custom printing services are also available so that jewelers can add their own <b>logo</b> or <b>branding</b> to the trays.</p>

            <p>Jewelry tray serves several important functions for organizing and preserving jewelry:</p>
            <ul>
              <li><b>Organization</b> : A jewelry tray helps keep your jewelry organized and prevents it from getting tangled or damaged. It provides specific compartments for different types of jewelry, such as rings, earrings, necklaces, bracelets, and watches.</li>
              <li><b>Prevents Tangling</b> : Necklaces and chains, in particular, have a tendency to get tangled if they're not stored properly. A tray with compartments or hooks helps prevent this, making it easier to access and wear your jewelry.</li>
              <li><b>Protects Against Scratches and Damage</b> : When jewelry is stored together without proper separation, it can lead to scratches and damage. A jewelry tray often has soft, lined compartments that help protect delicate items from abrasion.</li>
              <li><b>Visibility and Accessibility</b> : Transparent or open compartments make it easy to see all your jewelry at a glance. This can save time when you're getting ready and help you choose the right piece for your outfit.</li>
            </ul>

            <h3>Types of Jewelry Trays</h3>
            <p>Lussopack offers a wide range of jewelry trays to choose from, including:</p>
            <ul>
              <li><b>Necklace trays</b> : Necklace trays are designed to hold necklaces securely, preventing them from tangling or becoming damaged.</li>
              <li><b>Ring trays</b> : Ring trays are perfect for displaying and protecting rings of all sizes and styles.</li>
              <li><b>Bracelet trays</b> : Bracelet trays are ideal for holding bracelets of all shapes and sizes.</li>
              <li><b>Earring trays</b> : Earring trays are designed to keep earrings organized and protected.</li>
              <li><b>Jewelry sets trays</b> : Jewelry sets trays are ideal for packaging multiple pieces of jewelry together, such as a necklace, earrings, and bracelet.</li>
            </ul>

            <h3>Custom Jewelry Trays</h3>
            <p>Lussopack can customize your jewelry trays to meet your specific needs. We offer a variety of materials, colors, and finishes to choose from, and we can also print your logo and branding on the trays. Simply contact us today to discuss your custom jewelry tray needs.</p>
            <p>Jewelry trays are an essential part of jewelry packaging, offering a number of benefits, including protection, presentation, and branding. Lussopack offers a wide range of jewelry trays to choose from, and we can also customize your trays to meet your specific needs. Contact us today to learn more about our jewelry trays and to place an order.</p>

          </div>
        </Media>
        <Media lessThan="md">
          <div id="shoppingAidMobile">
              <h2>Jewelry Trays</h2>
              <div className="shoppingAidsList">
              {
                SHOPPING_AIDS_ITEM.map((shoppingAid, index)=>(
                  <div className={`shoppingAidsItem`} key={index}>
                    <Link to={toRoute(shoppingAid.path)}>
                      <Image
                        src={asset(`${shoppingAid.itemImageDesktop}`)}
                        alt={`${shoppingAid.item}`}
                        className="img-fluid"
                        width="345"
                        height="345"
                      />
                      <p>{shoppingAid.item}</p>
                    </Link>
                  </div>
                ))
              }
            </div>
            <p><b>Jewelry trays</b> are a great way for jewelers to display their products and make them more appealing to customers. They can also be used to <b>organize jewelry</b> in a retail setting or to <b>store jewelry at home.</b> Lussopack's jewelry trays are a great way for jewelers to improve the presentation of their products and <b>increase sales.</b></p>
            <p>We offer a wide variety of trays in different materials, sizes, and colors to suit the needs of any jeweler. Our produced trays are made from <b>high-quality materials</b> and are designed to <b>protect jewelry from damage.</b> Custom printing services are also available so that jewelers can add their own <b>logo</b> or <b>branding</b> to the trays.</p>

            <p>Jewelry tray serves several important functions for organizing and preserving jewelry:</p>
            <ul>
              <li><b>Organization</b> : A jewelry tray helps keep your jewelry organized and prevents it from getting tangled or damaged. It provides specific compartments for different types of jewelry, such as rings, earrings, necklaces, bracelets, and watches.</li>
              <li><b>Prevents Tangling</b> : Necklaces and chains, in particular, have a tendency to get tangled if they're not stored properly. A tray with compartments or hooks helps prevent this, making it easier to access and wear your jewelry.</li>
              <li><b>Protects Against Scratches and Damage</b> : When jewelry is stored together without proper separation, it can lead to scratches and damage. A jewelry tray often has soft, lined compartments that help protect delicate items from abrasion.</li>
              <li><b>Visibility and Accessibility</b> : Transparent or open compartments make it easy to see all your jewelry at a glance. This can save time when you're getting ready and help you choose the right piece for your outfit.</li>
            </ul>

            <h3>Types of Jewelry Trays</h3>
            <p>Lussopack offers a wide range of jewelry trays to choose from, including:</p>
            <ul>
              <li><b>Necklace trays</b> : Necklace trays are designed to hold necklaces securely, preventing them from tangling or becoming damaged.</li>
              <li><b>Ring trays</b> : Ring trays are perfect for displaying and protecting rings of all sizes and styles.</li>
              <li><b>Bracelet trays</b> : Bracelet trays are ideal for holding bracelets of all shapes and sizes.</li>
              <li><b>Earring trays</b> : Earring trays are designed to keep earrings organized and protected.</li>
              <li><b>Jewelry sets trays</b> : Jewelry sets trays are ideal for packaging multiple pieces of jewelry together, such as a necklace, earrings, and bracelet.</li>
            </ul>

            <h3>Custom Jewelry Trays</h3>
            <p>Lussopack can customize your jewelry trays to meet your specific needs. We offer a variety of materials, colors, and finishes to choose from, and we can also print your logo and branding on the trays. Simply contact us today to discuss your custom jewelry tray needs.</p>
            <p>Jewelry trays are an essential part of jewelry packaging, offering a number of benefits, including protection, presentation, and branding. Lussopack offers a wide range of jewelry trays to choose from, and we can also customize your trays to meet your specific needs. Contact us today to learn more about our jewelry trays and to place an order.</p>
          </div>
        </Media>
      </MediaContextProvider>
    </>
  );
}

export default ShoppingAids;
